import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import LutronDesignerClientProxy from "../../backend/clients/LutronDesignerClientProxy";
import Modal from "../../ui/Modal/Modal";
import srcSpinner from "../../assets/images/blue-spinner.gif";
import { useServiceWorkerContext } from "../ServiceWorkerContext/ServiceWorkerContext";

const MainFooter = styled.footer`
  background: var(--footer-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 50px;
  background: linear-gradient(
    347.16deg,
    rgba(255, 255, 255, 0.9) 47.53%,
    rgba(245, 245, 245, 0) 90.01%
  );
  backdrop-filter: blur(1.6875px);
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  bottom: 0;
`;

const PromptContainer = styled.div`
  box-shadow: 0px 0.75px 1.5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
  background: white;
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
`;

const Prompt = styled.span`
  margin-left: 10px;
`;

const BrowseLocal = styled.button`
  background: rgba(0, 0, 0, 0.78);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
`;

const Loader = styled.img`
  width: 100px;
  height: 100px;
`;

const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Footer = (): JSX.Element => {
  const { t } = useTranslation();
  const sw = useServiceWorkerContext();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openExistingProject = () => {
    setIsModalOpen(true);
    LutronDesignerClientProxy.openLocalRequest(sw.waitForInstalled);
  };

  return (
    <>
      {isModalOpen && (
        <Modal>
          <Center data-testid="loader-modal">
            <Loader src={srcSpinner} alt={t("loading")} />
          </Center>
        </Modal>
      )}
      <MainFooter>
        <PromptContainer>
          <Prompt>{t("footer.headline")}</Prompt>
          <BrowseLocal onClick={openExistingProject}>
            {t("actions.open_existing_project")}
          </BrowseLocal>
        </PromptContainer>
      </MainFooter>
    </>
  );
};

export default Footer;
